import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
export var StripeError = /*#__PURE__*/function (_Error) {
  _inherits(StripeError, _Error);
  var _super = _createSuper(StripeError);
  function StripeError() {
    var _this;
    var stripeError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, StripeError);
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(params));
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), StripeError);
    }
    var message = stripeError.message,
      type = stripeError.type,
      code = stripeError.code,
      declineCode = stripeError.decline_code;
    _this.name = 'StripeError';
    _this.displayableMessage = message;
    _this.message = message;
    _this.type = type;
    _this.code = code;
    _this.declineCode = declineCode;
    return _this;
  }
  return _createClass(StripeError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export function createStripePaymentMethod(_x, _x2) {
  return _createStripePaymentMethod.apply(this, arguments);
}
function _createStripePaymentMethod() {
  _createStripePaymentMethod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stripe, cardElement) {
    var _ref,
      _ref$nameOnCard,
      nameOnCard,
      _ref$postalCode,
      postalCode,
      _ref$type,
      type,
      response,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, _ref$nameOnCard = _ref.nameOnCard, nameOnCard = _ref$nameOnCard === void 0 ? '' : _ref$nameOnCard, _ref$postalCode = _ref.postalCode, postalCode = _ref$postalCode === void 0 ? '' : _ref$postalCode, _ref$type = _ref.type, type = _ref$type === void 0 ? 'card' : _ref$type;
          _context.next = 3;
          return stripe.createPaymentMethod({
            type: type,
            card: cardElement,
            billing_details: {
              name: nameOnCard,
              address: {
                postal_code: postalCode
              }
            }
          });
        case 3:
          response = _context.sent;
          if (!response.error) {
            _context.next = 6;
            break;
          }
          throw new StripeError(response.error);
        case 6:
          return _context.abrupt("return", response);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _createStripePaymentMethod.apply(this, arguments);
}
export function createStripeToken(_x3, _x4) {
  return _createStripeToken.apply(this, arguments);
}
function _createStripeToken() {
  _createStripeToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(stripe, cardElement) {
    var _ref2,
      _ref2$nameOnCard,
      nameOnCard,
      _ref2$postalCode,
      postalCode,
      response,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref2 = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {}, _ref2$nameOnCard = _ref2.nameOnCard, nameOnCard = _ref2$nameOnCard === void 0 ? '' : _ref2$nameOnCard, _ref2$postalCode = _ref2.postalCode, postalCode = _ref2$postalCode === void 0 ? '' : _ref2$postalCode;
          _context2.next = 3;
          return stripe.createToken(cardElement, {
            name: nameOnCard,
            address_zip: postalCode
          });
        case 3:
          response = _context2.sent;
          if (!response.error) {
            _context2.next = 6;
            break;
          }
          throw new StripeError(response.error);
        case 6:
          return _context2.abrupt("return", response);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createStripeToken.apply(this, arguments);
}